import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../components/Button/button";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { auth, warehouses } from "../../../redux/actions";
import SessionService from "../../../services/session-service";
import { useQuery } from "@tanstack/react-query";
import { getLoggedUsersData } from "../../../services/users/get-logged";
import { urlClient } from "../../../utils/url";
import { getAllWarehouses } from "../../../services/warehouses/get-all";
import ClientOrders from "../orders";
import { useEffect } from "react";

const ClientLoggedDashboard = () => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const { isLoading } = useQuery(["loggedUsersData"], getLoggedUsersData, {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onSuccess(data) {},
  });
  const body = {
    paginacja: null,
  };

  const getAllWarehousesClient = useQuery(
    ["warehouses"],
    () => getAllWarehouses(body),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        dispatch(warehouses.fetchAllWarehouses(data.data.payload.magazyny));
        SessionService.setWarehousesList(data.data.payload.magazyny);
        navigate("/orders");
      },
    }
  );
  const handleSubmitLogout = () => {
    SessionService.clearUserSession();
    SessionService.clearLoggedUserData();
    dispatch(auth.userLogout());
    navigate("/login");
  };

  return (
    <PageContainer>
      <h1>Panel Klienta</h1>
      <StyledButton
        style={{ width: "320px" }}
        onClick={() => navigate(urlClient.orderForm)}
      >
        Formularz
      </StyledButton>
    </PageContainer>
  );
};
const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 40px 0px;
  width: 100%;
  height: 100%;
`;

export default ClientLoggedDashboard;
